import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from '@angular/router';
import { Right } from './../../auth/_models/right';
import { User } from './../../auth/_models/user';
import { VetsService } from './../../auth/_services/vets.service';
import { ToastrService } from 'ngx-toastr';
import { BlockUi } from './../../auth/_helpers/block-ui';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Vet } from '../../auth/_models/vet';

@Component({
  selector: 'app-vet-create',
  templateUrl: './vet-create.component.html',
  styleUrls: ['./vet-create.component.css'],
  providers: [VetsService]
})
export class VetCreateComponent implements OnInit {

  formCreate: FormGroup;

  sending: boolean;

  constructor(
    private _formBuilder: FormBuilder,
    private _blockui: BlockUi,
    private _service: VetsService,
    private _tostr: ToastrService,
    private _router: Router,
    private _afAuth: AngularFireAuth,
  ) {

    this.formCreate = _formBuilder.group({
      name: [null, [Validators.required, Validators.minLength(3)]],
      phone: [null, [Validators.required]],
      crmv: [null, [Validators.required]],
      birthday: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
    });

  }

  /**
   *
   */
  ngOnInit() {
  }

  /**
   * Método de submit
   * */
  onSubmit() {

    const controls = this.formCreate.controls;
    const self = this;

    let vet: Vet;

    let name: string,
      email: string,
      phone: string,
      birthday: Date,
      document: string;

    /**
     * Verifica se o formulário é válido
     */
    if (this.formCreate.valid) {

      name = controls.name.value;
      email = controls.email.value;
      phone = controls.phone.value;
      // birthday = controls.birthday.value;
      document = controls.crmv.value;

      birthday = new Date(controls.birthday.value);
      birthday.setDate(birthday.getDate() + 1);

      /**
       * Valida se todos os campos foram preenchidos
       * mesmo depois do próprio angular validar o formulário
       * */
      if (name !== '' && email !== '' && phone !== '' && birthday.toString() !== '' && document !== '') {

        /** Trava a interface */
        this._blockui.block();

        if (!this.sending) {

          this.sending = true;

          /** Cria uma instância do Veterinário */
          vet = new Vet({
            name: name,
            phone: phone,
            birthday: new Date(birthday),
            document: document,
            user: new User({
              email: email,
              right: new Right({
                name: 'Veterinary',
                key: 'vet'
              })
            })
          });

          /** Envia a mensagem para que seja feito o insert */
          this._service
            .insertVet(vet)
            .then((data) => {
              self._blockui.unblock();
              self.resetForm();
              self._tostr.success('Veterinário cadastrado com sucesso.');
              self.sending = false;

              // if (email !== '') {
              //   this._afAuth.auth
              //     .sendPasswordResetEmail(email)
              //     .then(() => {
              //       console.log('E-mail enviado com sucesso.');
              //     });
              // } else {
              // Redirecionando
              this._router.navigate(['/veterinarios/detalhe', data.id]);
              // }
            })
            .catch((err) => {
              self._blockui.unblock();
              self._tostr.error('Ocorreu um erro ao cadastrar o veterinário.');
              self.sending = false;
            });
        }

      } else {
        this._blockui.unblock();
        this._tostr.warning('Nem todos os campos do formulário foram preenchidos.');
      }

    } else {
      this._blockui.unblock();
      this._tostr.warning('Existem alguns erros no formulário.');
    }

  }

  resetForm() {
    this.formCreate.reset();
  }

}
